module.exports = __webpack_public_path__ + "img/pig-way.88857c0e.png";